import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PromoRepository } from '../../repositories/promo.repository';
import { UseCase } from '@shared/helper';
import { GetContentDto, GetContentResp } from './get-content.interface';
@Injectable({
    providedIn: 'root'
})
export class GetContentUsecase implements UseCase<GetContentDto, GetContentResp> {
    promoRepository = inject(PromoRepository);

    execute(data: GetContentDto): Observable<GetContentResp> {
        return this.promoRepository.GetDataContent(data).pipe(
            map((res: GetContentResp) => {
            return {
                ...res,
                results: {
                    id: res.lang_id,
                    en: res.lang_en
                }
            };
        }));
    }
}
